import type { JavaScriptFunction } from '@unifyapps/defs/types/javascriptFunction';
import { produce } from 'immer';
import omit from 'lodash/omit';
import { DependencyHelper } from '../dependency/helpers/DependencyHelper';
import type { BuildDependencyGraphItem } from '../dependency/utils/buildDependencyGraph';
import type { DynamicAndConditionalPathHandler } from '../no-code/context/DependencyGraphProvider/handlers';
import {
  DEPENDENCY_KEYS_TO_OMIT_DURING_SERIALIZATION,
  NoCodeDependencyKeys,
} from '../no-code/dependency/const';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- false positive
export class PageFunctionHelper {
  static getDependsOn(pageFunction: JavaScriptFunction) {
    return pageFunction[NoCodeDependencyKeys.DependsOn] as JavaScriptFunction['dpOn'];
  }

  static updateDependency(
    pageFunction: JavaScriptFunction,
    dependencyItem?: BuildDependencyGraphItem<DynamicAndConditionalPathHandler>,
  ) {
    return produce(pageFunction, (draft) => {
      draft[NoCodeDependencyKeys.DependsOn] = DependencyHelper.getDependsOn(dependencyItem);
    });
  }

  static getDataSourceIds(pageFunction: JavaScriptFunction) {
    return pageFunction.dataSourceIds ?? [];
  }

  static getAdaptedPageFunctionForDependencyGraph(pageFunction: JavaScriptFunction) {
    return omit(pageFunction, DEPENDENCY_KEYS_TO_OMIT_DURING_SERIALIZATION);
  }
  static omitIdAndCreatedTime<T extends JavaScriptFunction>(pageFunction: T) {
    return omit(pageFunction, 'id', 'createdTime') as Omit<T, 'id' | 'createdTime'>;
  }
}
